import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { useQuery } from "@apollo/client";
import toast from "react-hot-toast";
import eligibility from "../../gql/eligibility";
import ReactJsonView from "./components/ReactJsonView";
import { MdArrowBack, MdDownload, MdOutlineRemoveRedEye } from "react-icons/md";
import ReactJsonTree from "./components/ReactJsonTree";
import { set } from "lodash";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import AppTable from "../../shared/AppTable";
import AppButton from "../../shared/AppButton";
import ModernJsonReader from "../../shared/ModernJsonReader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EligibilityJsonViewModal({
  open,
  setOpen,
  handleClose,
  selectedItem,
}) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [logs, setLogs] = useState([]);
  const [item, setItem] = useState(null);
  const [showJsonView, setShowJsonView] = useState(false);
  const [jsonObject, setJsonObject] = useState(false);

  const [jsonDialogOpen, setJsonDialogOpen] = useState(false);

  const handleJsonDialogOpen = () => {
    setJsonDialogOpen(true);
  };

  const handleJsonDialogClose = () => {
    setJsonDialogOpen(false);
  };

  const showJson = (item) => {
    setJsonObject(item);
    setShowJsonView(true);
    setJsonDialogOpen(true);
    // handleClose();
  };

  const onCloseShowJson = () => {
    setShowJsonView(false);
  };

  const { loading, error, data, refetch } = useQuery(
    eligibility.GET_TRANSACTION_DETAILS_LOGS,
    {
      variables: {
        transactionId: selectedItem?.transaction_id,
      },
      skip: !selectedItem?.transaction_id,
    },
  );

  // useEffect(() => {
  //   if (data) {
  //     setItem(data?.getVerificationTransaction?.data);
  //   }
  // }, [data]);
  useEffect(() => {
    if (data?.getVerificationTransaction?.data?.logs) {
      setLogs(data.getVerificationTransaction.data.logs);
    }
  }, [data]);

  const formatDate = (backendDateTime) => {
    // Create a new Date object using the backend datetime value
    const date = new Date(backendDateTime);

    // Extract day, month, and year components
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear());

    // Format the components as "dd-mm-yyyy"
    return `${day}-${month}-${year}`;
  };

  const downloadFile = ({ data, fileName, fileType }) => {
    // Create a blob with the data we want to download as a file
    const blob = new Blob([data], { type: fileType });
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToJson = (item) => {
    downloadFile({
      data: JSON.stringify(JSON.parse(item.log)),
      fileName: `${item.type}.json`,
      fileType: "text/json",
    });
  };
  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => index + 1,
    },
    {
      header: t("Transaction ID"),
      field: "transaction_id",
    },
    {
      header: t("Transaction Types"),
      field: "type",
      render: (row) => <span className="capitalize">{t(row.type)}</span>,
    },
    {
      header: t("Date"),
      render: (row) => formatDate(row.timestamp),
    },
  ];
  // console.log("jo", item?.logs ? JSON.parse(item?.logs[0]?.log) : []);
  // Data ko safe parse karne ka function
  const getParsedData = (data) => {
    if (typeof data === "string") {
      try {
        return JSON.parse(data);
      } catch (e) {
        return { error: "Invalid JSON String", raw: data };
      }
    }
    return data;
  };
  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={() => {
          jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
        }}
        TransitionComponent={Transition}
        sx={{ zIndex: 100 }}
      >
        <AppBar sx={{ position: "relative", background: "#0070C2" }}>
          <Toolbar className="">
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {t("Eligibility JSON View")}
            </Typography>
            <Button
              autoFocus
              size="small"
              color="inherit"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
            >
              {t("Close")}
            </Button>
          </Toolbar>
        </AppBar>

        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            {jsonDialogOpen ? (
              <div className="animate-fade-in p-4">
                <div className="mb-2">
                  <AppButton
                    label={t("Back to List")}
                    variant="outlined"
                    onClick={() => setJsonDialogOpen(false)}
                    startIcon={
                      <MdArrowBack className={isRTL ? "rotate-180" : ""} />
                    }
                  />
                </div>
                {/* <ReactJsonTree data={jsonObject} /> */}
                <ModernJsonReader data={getParsedData(jsonObject)} />
              </div>
            ) : (
              <div className="pt-4 px-8 mt-3">
                <AppTable
                  columns={columns}
                  data={logs}
                  loading={loading}
                  onView={(row) => showJson(row.log)}
                  onDownload={(row) => exportToJson(row)}
                  actions={true}
                />
              </div>
            )}
          </>
        )}
      </Dialog>
      {/* <ReactJsonView
        showJsonView={showJsonView}
        onCloseShowJson={onCloseShowJson}
        jsonObject={jsonObject}
      /> */}

      {/* <AppModal isOpen={loading} /> */}
    </div>
  );
}
